import { HARD_LIMITS } from "./criteria.js";
import { drynessScoreFromRainfall } from "./scoring.js";

// Beoordeelt de harde eisen van het gezin tegen de data.
// status: "pass" | "warn" | "fail" | "info"
// Geeft een lijst die zowel in de TownModal (checklist) als op de
// PlaceCard ("x/6 eisen") gebruikt wordt.
export function hardCriteriaCheck(town, concelho) {
  const cl  = concelho?.climate || {};
  const out = [];

  // 1. Afstand tot zee (minuten rijden)
  const sea = town?.hardRequirements?.seaDistanceMin;
  if (sea != null) {
    out.push({
      id: "sea", icon: "🌊", label: `Zee ${sea} min`,
      status: sea <= HARD_LIMITS.seaDistanceMax ? "pass" : sea <= 40 ? "warn" : "fail",
    });
  }

  // 2. Montessori binnen bereik
  const mon = town?.nearest_montessori;
  if (mon?.km != null) {
    const km = Math.round(mon.km);
    out.push({
      id: "montessori", icon: "🏫", label: `Montessori ${km} km`,
      status: km <= 30 ? "pass" : km <= 60 ? "warn" : "fail",
    });
  } else {
    out.push({ id: "montessori", icon: "🏫", label: "Montessori >100 km", status: "fail" });
  }

  // 3. Zomerpiek (95e percentiel)
  if (cl.summer_max_p95 != null) {
    const t = cl.summer_max_p95;
    out.push({
      id: "heat", icon: "🌡", label: `Zomer ${t}°C`,
      status: t <= 37 ? "pass" : t <= HARD_LIMITS.summerMaxP95Max ? "warn" : "fail",
    });
  }

  // 4. Droger dan Zwolle
  if (cl.annual_rainfall_mm != null) {
    const mm = cl.annual_rainfall_mm;
    out.push({
      id: "dryness", icon: "🌧", label: `${mm} mm neerslag`,
      status: mm <= HARD_LIMITS.annualRainfallMaxMm ? (drynessScoreFromRainfall(mm) >= 4 ? "pass" : "warn") : "fail",
    });
  }

  // 5. Groen / bergachtig
  const nature = town?.scores?.natureAccess ?? 0;
  if (town?.nature_type || nature) {
    out.push({
      id: "nature", icon: "🌿", label: "Groen / bergachtig",
      status: nature >= 4 ? "pass" : nature >= 3 ? "warn" : "fail",
    });
  }

  // 6. Brandrisico (ICNF-klasse)
  const fire = concelho?.fire_risk_class;
  if (fire != null) {
    out.push({
      id: "fire", icon: "🔥", label: `Brandrisico ${fire}/5`,
      status: fire <= 2 ? "pass" : fire <= HARD_LIMITS.fireRiskMaxClass ? "warn" : "fail",
    });
  }

  return out;
}

export function countPass(items) {
  return items.filter(i => i.status === "pass").length;
}

export const STATUS_META = {
  pass: { color: "#3b7a35", symbol: "✓" },
  warn: { color: "#c17f2a", symbol: "⚠" },
  fail: { color: "#c94040", symbol: "✗" },
  info: { color: "#888",    symbol: "?" },
};
